module.exports = __webpack_public_path__ + "static/img/failed_icon.f1b3277.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payment/failed_icon.png
// module id = JwE2
// module chunks = 1